import { lazy } from 'react';

import { PageSuspense } from 'src/components';


const AccountProductOrderPage = lazy(() => import('../views/list/AccountProductOrderPage'));

export function AccountProductOrderPageLazy() {
	return (
		<PageSuspense>
			<AccountProductOrderPage />
		</PageSuspense>
	);
}
